var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.forms[_vm.step],{tag:"component",attrs:{"type":`email`,"csrf":_vm.csrf,"position":_vm.position,"links":_vm.links,"email":_vm.email,"uid":_vm.uid,"until":_vm.until},on:{"go-step":function($event){return _vm.goStep($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }